var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolimorphicShapeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2310,
    height: 2588,
    viewBox: "0 0 2310 2588",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7119_1853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1740.07 1162.35C2100.12 1417.65 1803.92 1425.08 1617.28 1716.26C1575.38 1714.74 1468.13 1754.72 1374.29 1926.74C1257 2141.78 1018.73 2290.24 827.811 2100.16C636.887 1910.08 859.631 1915.87 603.392 1577.98C347.152 1240.1 387.492 1374.22 437.39 989.349C487.289 604.475 803.334 167.181 1217.66 544.583C1617.28 908.583 1380.01 907.041 1740.07 1162.35Z",
    fill: "#00FF9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7119_1853",
    x: 0.387207,
    y: -0.00686646,
    width: 2309.46,
    height: 2587.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_7119_1853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolimorphicShapeGreen);
export default __webpack_public_path__ + "static/media/polimorphic_shape_green.1ced261a272890bbfb2ebe0cab0c7203.svg";
export { ForwardRef as ReactComponent };